const listMove = (list, oldIndex: number, newIndex: number) => {
  const oldItem = list.get(oldIndex)
  return list.delete(oldIndex).insert(newIndex, oldItem)
}

export default listMove
